var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgM(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 198,
    viewBox: "0 0 189 198",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M145.873 105.156L154.76 86.8892V198H145.873V105.156ZM162.659 75.0407L172.533 51.8682V198H162.659V75.0407ZM112.561 116.511L107.624 106.174L162.659 0H172.533L112.561 116.511ZM103.675 99.7251L99.4667 90.8387L145.873 0H154.76L103.675 99.7251ZM34.2998 84.4516L43.1862 102.946V198H34.2998V84.4516ZM17.5144 51.8682L26.4008 69.641V198H17.5144V51.8682ZM81.6939 146.348H71.8201L8.6087 16.3804V198H0V0H9.68478L81.6939 146.348ZM99.4667 146.348H89.5929L17.5144 0H29.2935L99.4667 146.348ZM180.432 16.3804L119.207 146.348H106.378L37.2619 0H48.663L114.536 133.296L180.432 0H188.589V198H180.432V16.3804Z",
    fill: "#373737"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM);
export default __webpack_public_path__ + "static/media/M.ced3e71d64d92395c2a953d4b3eaebbf.svg";
export { ForwardRef as ReactComponent };